/**
 * @generated SignedSource<<7dd3bb8b9f83fc9d93919ac206bfe606>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_tradePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "interiorsPhotosTracking_tradePhoto";
};
export type interiorsPhotosTracking_tradePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_tradePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_tradePhoto"
};

(node as any).hash = "4076e4cc86f72f95184913cc48d5c02a";

export default node;
